import { ref } from '@vue/runtime-dom'

// 业务类型
export const businessTypeEnum = {
  1: '备案',
  2: '转移',
  3: '查看违章'
}

// 计费周期
export const billingCycleEnum = {
  1: '月付',
  2: '季付',
  3: '年付'
}

// 付款方式
export const payTypeEnum = {
  1: '一次性',
  2: '分期',
  3: '先用后付',
  4: '赠送'
}

// 合同状态
export const statusEnum = {
  1: '生效',
  0: '作废'
}

export const getTableConfig = () => {
  const common = {
    isSelection: false,
    loading: false,
    stripe: true,
    height: null,
    size: 'small',
    isIndex: true,
    indexLabel: '序号',
    data: []
  }

  const pagination = {
    isShow: true,
    total: 0,
    pageSize: 20,
    currentPage: 1,
    pageSizes: [10, 20, 40, 80, 100]
  }

  const column = [
    {
      key: 'contractNo',
      label: '合同编号',
      width: '170'
    },
    {
      key: 'companyName',
      label: '所属公司',
      width: '160'
    },
    {
      key: 'businessTypeMsg',
      label: '业务类型',
      width: '100'
    },
    {
      key: 'quota',
      label: '名额数量',
      width: '90'
    },
    {
      key: 'unitPrice',
      label: '单价（元/辆/天）',
      width: '130'
    },
    {
      key: 'totalAmount',
      label: '批次金额（元）',
      width: '120'
    },
    {
      key: 'billingCycle',
      label: '计费周期',
      width: '90',
      formatter: (row: any) => {
        return billingCycleEnum[row.billingCycle] || '-'
      }
    },
    {
      key: 'payType',
      label: '付款方式',
      width: '90',
      formatter: (row: any) => {
        return payTypeEnum[row.payType] || '-'
      }
    },
    {
      key: 'startTime',
      label: '批次起始',
      width: '110',
      formatter: (row: any) => (row.startTime || '').slice(0, 10) || '-'
    },
    {
      key: 'expireTime',
      label: '批次到期',
      width: '110',
      formatter: (row: any) => (row.expireTime || '').slice(0, 10) || '-'
    },
    {
      key: 'status',
      label: '状态',
      width: '80',
      slot: 'status'
    },
    {
      key: 'remark',
      label: '备注',
      width: '140'
    },
    {
      key: 'createBy',
      label: '录入人',
      width: '100'
    },
    {
      key: 'createTime',
      label: '录入时间',
      width: '110',
      formatter: (row: any) => (row.createTime || '').slice(0, 10) || '-'
    },
    {
      key: 'action',
      label: '操作',
      width: '100',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置
export const inputList = (remoteData1: any) => [
  {
    type: 'select',
    label: '所属公司',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod
  },
  {
    type: 'input',
    label: '合同编号',
    key: 'contractNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '业务类型',
    key: 'businessType',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: [
      { label: '备案', value: 1 },
      { label: '转移', value: 2 },
      { label: '查看违章', value: 3 }
    ]
  },
  {
    type: 'select',
    label: '状态',
    key: 'status',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: [
      { label: '生效', value: 1 },
      { label: '作废', value: 0 }
    ]
  },
  {
    type: 'select',
    label: '付款方式',
    key: 'payType',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: [
      { label: '一次性', value: 1 },
      { label: '分期', value: 2 },
      { label: '先用后付', value: 3 },
      { label: '赠送', value: 4 }
    ]
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  const page = {
    queryForm: ref<any>({}),
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}
